module.exports = __webpack_public_path__ + "img/seta-para-direita.1a89e5ea.svg";